import { z } from 'zod'

export const createManualTotalSchema = z.object({
  balance: z.number(),
  date: z
    .string()
    .datetime({ offset: true })
    .refine((v) => new Date(v).getTime() <= Date.now(), 'date cannot be in the future')
    .optional(),
})

export type CreateManualTotalDto = z.infer<typeof createManualTotalSchema>
